<template>
    <b-modal id="bv-modal-show-picacode" centered>
        <template slot="modal-header">
            <div class="d-block text-center">
                <h5 class="modal-title">{{ $t('modal_show_picacode.title') }}</h5>
                <h4 class="modal-subtitle pt-2">{{ $t('modal_show_picacode.subtitle') }}</h4>
            </div>
            <button type="button" aria-label="Close" class="close" @click="$bvModal.hide('bv-modal-show-picacode')"></button>
        </template>

        <div class="d-block text-center">
            <h3 class="h1 code">{{ picacode }}</h3>
        </div>

        <template slot="modal-footer" slot-scope="{ ok, cancel }">
            <b-button variant="dark" size="md" @click="cancel()">
                {{ $t('modal_show_picacode.action_cancel') }}
            </b-button>
        </template>
    </b-modal>
</template>


<script>
export default {
    props: ['picacode'],
}
</script>
